import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { ProfileField } from "@/portals/(shared)/(profile)/components/ProfileField";

import { usePracticeList } from "../api/queries/usePracticeList";

export function AssociatedPracticeCard() {
  const { data: practiceList } = usePracticeList();

  return (
    <DashboardCard2 title="Associated Practice">
      <div className="tw:grid tw:grid-cols-1 tw:gap-x-4 tw:gap-y-2 tw:md:grid-cols-2">
        {practiceList?.map((item, index) => (
          <ProfileField key={item.name + index} title={item.name} value={item.general_email} />
        ))}
      </div>
    </DashboardCard2>
  );
}
